import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { Card, CardContent } from '@mui/material'
import { getFullDateMini } from 'utils/DateUtil'

const UpdateEntityPanel = ({
    updateLogin = '',
    updateDate = 0,
    entityName = '',
}) => !!updateLogin && !!updateDate && !!entityName && (
    <Card>
        <CardContent>
            <span>"{entityName}" - {i18n.entityUpdatedAt} {getFullDateMini(updateDate)} {i18n.by} {updateLogin} </span>
        </CardContent>
    </Card>
)

UpdateEntityPanel.propTypes = {
    updateLogin: PropTypes.string,
    updateDate: PropTypes.number,
    entityName: PropTypes.string,
}

export default UpdateEntityPanel